import React from "react";
import styled from "styled-components";

export default function LoadingPopup () {

return (
    <StyledPopup>
        <div className="container">
            <h1> LOADING... </h1>
            <div className="spinner"/>
        </div>
    </StyledPopup>
)
}



const StyledPopup = styled.div` 
width: 100vw;
left: 0;
top: 6rem;
position: absolute;
.container {
    color: black; 
    gap: 3rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center; 
    background-color: #D3D3D3;    
    .spinner {
        align-items: center;
        justify-content: center;
        padding: 4rem;
        border: 16px solid #fbc490;
        border-top: 16px #f67b50 solid;
        border-radius: 50%;
        height: 120px;
        width: 120px;
        animation: spin 2s linear infinite;

        @keyframes spin {
        0% {
            transform: rotate(0deg);
        }

        100% {
            transform: rotate(360deg);
        }
        }
    }
}
`;


  